meedy.factory('meedy.mdxOrderModel', ['$rootScope', '$q', 'meedyConfig', 'meedy.baseModel', 'fileHelper', 'meedy.mdxOrderService',
    function ($rootScope, $q, config, baseModel, fileHelper, mdxOrderService) {

        function MdxOrderModel() {

            this.getOrderDetailsForTerms = function (icrIds) {

                var ordersDetails = {};

                var promises = _.map(icrIds, function (icrId) {
                    return mdxOrderService.getOrderDetails(icrId).then(
                        function (details) {
                            ordersDetails[details.id] = details;
                            return details;
                        },
                        function (error) {
                            $q.reject(error);
                        }
                    );
                });

                return $q.all(promises)
                    .then(function (data) {
                        return ordersDetails;
                    });
            };

            this.getOrderDetails = function (id) {
                return mdxOrderService.getOrderDetails(id).then(
                    function (orderDetails) {
                        $rootScope.$broadcast(Event.MEEDY.MDX.ORDER.GET_ORDER_DETAILS.SUCCESS, orderDetails);
                        return orderDetails;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.MDX.ORDER.GET_ORDER_DETAILS.ERROR, error);
                        $q.reject(error);
                    }
                )
            };

            this.getOrderFiles = function (criteria) {
                return mdxOrderService.getOrderFiles(criteria).then(
                    function (orderFilesDataPage) {
                        $rootScope.$broadcast(Event.MEEDY.MDX.ORDER.GET_ORDER_FILES.SUCCESS, orderFilesDataPage);
                        return orderFilesDataPage;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.MDX.ORDER.GET_ORDER_FILES.ERROR, error);
                        $q.reject(error);
                    }
                )
            };

            this.downloadFile = function (orderId, fileId) {
                mdxOrderService.getDownloadToken(orderId, fileId).then(function (tokenWrapper) {
                    window.location = config.MDX_FILE_DOWNLOAD_PREFIX + '/download?token=' + tokenWrapper.token;
                }, function () {
                    console.log('downloadFile failed');
                    // $rootScope.$broadcast(Event.ORDER_FILE.DOWNLOAD_FILE.ERROR, event);
                    // baseModel.broadcastOperationFailed();
                });
            };

            this.downloadMergedFiles = function (orderId, fileIds, downloadType) {
                return mdxOrderService.getDownloadMergedFilesToken(orderId, fileIds, downloadType).then(function (tokenWrapper) {
                    var downloadUrl = config.MDX_FILE_DOWNLOAD_PREFIX + '/download?token=' + tokenWrapper.token;
                    window.location = downloadUrl;
                }, function () {
                    console.log('downloadFile failed');
                    // $rootScope.$broadcast(Event.ORDER_FILE.DOWNLOAD_MERGED_FILES.ERROR, event);
                    // baseModel.broadcastOperationFailed();
                });
            };
	
			this.sendFileAttachedEmail = function (mdxSendFileAttachedEmail) {
				return mdxOrderService.sendFileAttachedEmail(mdxSendFileAttachedEmail).then(
					function(successResponse) {
						$rootScope.$broadcast(Event.MEEDY.MDX.ORDER.SEND_FILE_ATTACHED_EMAIL.SUCCESS, successResponse);
						return successResponse;
					},
					function(errorResponse) {
						$rootScope.$broadcast(Event.MEEDY.MDX.ORDER.SEND_FILE_ATTACHED_EMAIL.ERROR, errorResponse);
						return $q.reject(errorResponse);
					}
				);
			};


            this.uploadFiles = function (orderId, enclosedFiles) {
                var uploaded = [];
                var notUploaded = [];
                var promises = _.map(enclosedFiles, function (enclosedFile) {
                    return encloseFile(orderId, enclosedFile, uploaded, notUploaded);
                });

                return $q.all(promises)
                    .then(function () {
                        return uploaded;
                    })
                    .catch(function () {
                        return $q.reject({uploaded: uploaded, notUploaded: notUploaded});
                    });
            };

            function encloseFile(orderId, enclosedFile, uploaded, notUploaded) {
                var deffered = $q.defer();

                fileHelper.getMD5(enclosedFile)
                    .then(function (md5sum) {
                        return mdxOrderService.getUploadToken(orderId, enclosedFile.size, md5sum).then(function (tokenWrapper) {
                            var formData = fileHelper.getFileFormData(enclosedFile, tokenWrapper.token, md5sum, Enum.MDX_FILE_TYPE.ORDER_FILES);
                            return mdxOrderService.uploadFile(formData).then(
                                function (data) {
                                    uploaded.push(enclosedFile);
                                    deffered.resolve(data);
                                },
                                function (error) {
                                    notUploaded.push(enclosedFile);
                                    deffered.reject(error);
                                }
                            );
                        }, function (error) {
                            notUploaded.push(enclosedFile);
                            deffered.reject(error);
                        });

                    })
                    .catch(function (event) {
                        notUploaded.push(enclosedFile);
                        deffered.reject(error);
                    });

                return deffered.promise;
            }

            this.deleteFiles = function (ids) {
                return mdxOrderService.deleteFile(ids[0]).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.MDX.ORDER.DELETE_FILES.SUCCESS, data);
                        return data;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.MDX.ORDER.DELETE_FILES.ERROR, error);
                        $q.reject(error);
                    }
                );
            };

        }

        return new MdxOrderModel();
    }
]);
